<template>
  <v-btn icon small @click="backToLandingPage()" class="back-btn">
		<v-icon>mdi-chevron-left</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'BackButton',
  computed: {
    accentColor() {
      return this.$store.state.accentColor;
    },
    currentTree() {
      return this.$store.state.currentTreeLocation;
    },
    itemsByCategoriesNew() {
      return this.$store.state.itemsByCategories;
    },
    customerSawItemsScreen() {
      return this.$store.state.sawItems;
    },
  },
  methods: {
    backToLandingPage() {
      if (this.customerSawItemsScreen) {
        if (this.currentTree && this.currentTree.length) {
          this.$store.dispatch('goToPreviousCategory');
        } else {
          this.$store.commit('updateShowLandingPage', true);
          this.$store.commit('updateShowSubCategoryMenu', false);
          this.$store.commit('updateCategorySelectIndex', '000');
        }
      } else {
        const smallerTree = this.currentTree.slice(0, -1);
        if (smallerTree && smallerTree.length) {
          this.$store.dispatch('goToPreviousCategory');
        } else {
          this.$store.commit('updateShowLandingPage', true);
          this.$store.commit('updateShowSubCategoryMenu', false);
          this.$store.commit('updateCategorySelectIndex', '000');
        }
      }
    },
  },
};
</script>

<style scoped>
.back-btn .v-icon {
  font-size: 28px;
}
</style>
